
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import CButtonGroup from '@/components/c-button-group'
import { getIndexConfig, getTableConfig, inputList } from './config'
import { usePagination } from '@/hooks/usePagination'
import { defineComponent, reactive, toRefs, onMounted, computed } from 'vue'
import { page, close } from './api'
import Edit from './edit.vue'
import { useEnterpriseRemote } from '../enterprise-remote'
import { toResult } from '@/utils/toResult'
import { ElMessage, ElMessageBox } from 'element-plus'

export default defineComponent({
  components: {
    CSearchList,
    CTable,
    CButtonGroup,
    Edit
  },
  setup() {
    const remoteData1 = useEnterpriseRemote()
    const data = reactive({
      ...getIndexConfig(),
      isedit: false
    })

    const inputListComputed = computed(() => inputList(remoteData1))

    const tableConfig = reactive({
      ...getTableConfig()
    })

    const getListFn = async () => {
      const p = {
        ...data.queryForm,
        currPage: tableConfig.pagination.currentPage,
        pageSize: tableConfig.pagination.pageSize
      }
      const [err, res] = await toResult(page(p))
      if (err) return false
      // 后端 PageResult 字段为 list/total（toResult 已解包到 data 层）
      tableConfig.data = res.list || []
      tableConfig.pagination.total = res.total || 0
    }

    // 查询
    const handleSearch = (params) => {
      tableConfig.pagination.currentPage = 1
      params && (data.queryForm = { ...params })
      getListFn()
    }

    // 重置
    const handleReset = (val) => {
      data.queryForm = val
    }

    const { pageCurrentChange, pageSizeChange } = usePagination(
      tableConfig.pagination,
      () => {
        getListFn()
      }
    )

    // 关闭合同
    const handleClose = (row) => {
      ElMessageBox.confirm(
        `关闭后合同「${row.contractNo}」立即作废，剩余名额额度失效，该合同名下已授权车辆将立即取消授权（授权记录留痕，可在操作记录中查看）。是否确认关闭？`,
        '关闭合同',
        {
          confirmButtonText: '确认关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(async () => {
        const [err] = await toResult(close({ id: row.id }))
        if (err) return false
        ElMessage.success('关闭成功')
        getListFn()
      })
    }

    // 新增按钮操作
    const btnHandle = (type) => {
      if (type === 'add') {
        data.isedit = !data.isedit
      }
    }

    onMounted(() => {
      handleSearch({})
    })

    return {
      ...toRefs(data),
      inputListComputed,
      handleSearch,
      handleReset,
      handleClose,
      tableConfig,
      pageCurrentChange,
      pageSizeChange,
      getListFn,
      btnHandle
    }
  }
})
